import React from 'react'
import '../styles/our_work.css'
import SubNav from '../components/subNav'
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const our_work = () => {
  return (
    <>
    <SEO
      title="Our Work"
      description="Explore ProducerBuddy's portfolio of film production projects and success stories from filmmakers worldwide."
      url="https://producerbuddy.pilomation.com/our-work"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='work'>
      <div className='heading'>
        <h3><b>Ensuring our customers' satisfaction is at the heart of everything we do.</b></h3>
        <p className='mt-4'>Lorem ipsum dolor sit amet. Est ipsam voluptatem et beatae saepe et enim reprehenderit non molestiae magnam est laudantium obcaecati! Aut dolor magnam et odit voluptatem sed recusandae 
            facere sit repudiandae iste est accusamus veritatis aut unde dolor et maiores dolores. Est corporis rerum aut delectus error in quia sapiente non harum perspiciatis.</p>
      </div>
      <div className='description'>
        <div className='sub_description'>
            <h4>What we are?</h4>
            <p className='mt-2'>Lorem ipsum dolor sit amet. Est ipsam voluptatem et beatae saepe et enim reprehenderit non molestiae magnam est laudantium obcaecati! Aut dolor magnam et odit voluptatem sed recusandae 
            facere sit repudiandae iste est accusamus veritatis aut unde dolor et maiores dolores</p>
        </div>
        <img src='https://via.placeholder.com/150' alt='image'/>
      </div>
      <div className='description'>
      <img src='https://via.placeholder.com/150' alt='image'/>
        <div className='sub_description'>
            <h4>What we are?</h4>
            <p className='mt-2'>Lorem ipsum dolor sit amet. Est ipsam voluptatem et beatae saepe et enim reprehenderit non molestiae magnam est laudantium obcaecati! Aut dolor magnam et odit voluptatem sed recusandae 
            facere sit repudiandae iste est accusamus veritatis aut unde dolor et maiores dolores</p>
        </div>
      </div>
    </div>
    </>
  )
}

export default our_work


